import i18n from '../VueI18n'

/**
 *
 * @param {Object} produto Produto que deve ser validada
 * @param {Array<Object>} produtos Lista de produtos que devem ser usados para validacao
 */
const validarProduto = (produto, produtos) => {
	let result = { isValid: true, message: [] }

	if (!isUnique(produto, produtos)) {
		result.isValid = false
		result.message.push(
			`${i18n.t('oProduto')} "${produto.tppr_ds_descricao}" ${i18n.t('jaEstaCadastradaNoSistema')}`,
		)
	}

	// if (!minimoMenorQueMaximo(produto.tppr_md_diametro_min, produto.tppr_md_diametro_max)) {
	//     result.isValid = false;
	//     result.message.push(`O diâmetro minimo do produto está maior do que o diâmetro máximo`);
	// }

	// if (!minimoMenorQueMaximo(produto.tppr_md_comprimento_min, produto.tppr_md_comprimento_max)) {
	//     result.isValid = false;
	//     result.message.push(`O comprimento minimo do produto está maior do que o comprimento máximo`);
	// }

	return result
}

/**
 * Valida se o produto possui valores unicos considerando:
 * - tppr_ds_descricao
 * @param {Object}  produto que deve ser validado
 * @param {Array<Object>} produtos Lista de parcelas que devem ser usados para validacao
 */
function isUnique(produto, produtos) {
	return (
		produtos.filter(
			(produtoDaLista) =>
				produtoDaLista.tppr_ds_descricao.toLowerCase() === produto.tppr_ds_descricao.toLowerCase(),
		).length === 0
	)
}

export default validarProduto
